import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes.js";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../components/spinner";

const CatalogoObrasAsignada = (props) => {
  let op = require("../../src/modulos/datos.js");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "Nº ASIGNACION", textAlign: "center" },
    { label: "DESCRIPCION", textAlign: "center" },
    { label: "EMPRESA ASIGNADA", textAlign: "center" },
    { label: "ID OBRA", textAlign: "center" },
    { label: "ID PROVEEDOR", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idobraasignada.includes(target.value) ||
              x.descripcionobra
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.razonsocial
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.idobra.includes(target.value) ||
              x.idproveedor.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarObraAsignada = () => {
    let compro = props.status;
    let endpoint = `${op.conexion}/api/catalogo/obrasasignadaaprob?idefiscal=${idefiscal}&compro=${compro}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var data = [];
          for (let i = 0; i < response.data.length; i++) {
            data.push({
              idobraasignada: response.data[i].idobraasignada,
              descripcionobra: response.data[i].descripcionobra,
              razonsocial: response.data[i].razonsocial,
              idobra: response.data[i].idobra,
              idproveedor: response.data[i].idproveedor,
            });
          }
          setRecords(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const selectObraAsig = () => {
    var idobraasignada = values[0].idobraasignada;
    var descripcionobra = values[0].descripcionobra;
    var razonsocial = values[0].razonsocial;
    var idobra = values[0].idobra;
    var idproveedor = values[0].idproveedor;

    blanquear();
    props.onHideAceptaObra(
      idobraasignada,
      descripcionobra,
      razonsocial,
      idobra,
      idproveedor,
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var idobraasignada = recordsAfterPagingAndSorting()[index].idobraasignada;
    var descripcionobra = recordsAfterPagingAndSorting()[index].descripcionobra;
    var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
    var idobra = recordsAfterPagingAndSorting()[index].idobra;
    var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;

    var datos = [];
    datos.push({
      idobraasignada,
      descripcionobra,
      razonsocial,
      idobra,
      idproveedor,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarObraAsignada();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Obras / Servicios</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "80px" }}>
                      {item.idobraasignada}
                    </td>
                    <td className="py-2 text-start" style={{ width: "250px" }}>
                      {item.descripcionobra}
                    </td>
                    <td className="py-2 text-start" style={{ width: "100px" }}>
                      {item.razonsocial}
                    </td>
                    <td className="py-2 text-center" style={{ width: "80px" }}>
                      {item.idobra}
                    </td>
                    <td className="py-2 text-center" style={{ width: "80px" }}>
                      {item.idproveedor}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={selectObraAsig}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoObrasAsignada;
